import { useEffect, useRef } from "react";

const AutoResizeTextarea = ({ value, onChange, onBlur, placeholder, className }) => {
  const textareaRef = useRef(null);

  const autoResize = (el) => {
    el.style.height = "auto"; // reset
    // Add a small buffer so larger fonts do not get clipped by borders.
    el.style.height = Math.max(el.scrollHeight + 4, 32) + "px";
  };

  useEffect(() => {
    if (textareaRef.current) autoResize(textareaRef.current);
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      className={className}
      value={value || ""}
      onChange={(e) => {
        onChange(e.target.value);
        autoResize(e.target);
      }}
      onBlur={onBlur}
      placeholder={placeholder}
    />
  );
};
export default AutoResizeTextarea;